// extracted by mini-css-extract-plugin
module.exports = {"title":"MetadataForm_title__1Mq6I","subtitle":"MetadataForm_subtitle__1bOon"};